var map = {
	"./App": 13446,
	"./App.vue": 13446,
	"./assets/css/global.scss": 70656,
	"./assets/css/reset.scss": 64410,
	"./assets/css/utils.scss": 76906,
	"./assets/fonts/AHKIO LIGHT.OTF": 21821,
	"./assets/fonts/HARMONYOS_SANS_BOLD.TTF": 35981,
	"./assets/fonts/HARMONYOS_SANS_MEDIUM.TTF": 14514,
	"./assets/fonts/HARMONYOS_SANS_REGULAR.TTF": 39773,
	"./assets/fonts/font.css": 7903,
	"./assets/icons": 17258,
	"./assets/icons/": 17258,
	"./assets/icons/index": 17258,
	"./assets/icons/index.js": 17258,
	"./assets/icons/svg/icon-arrow.svg": 51089,
	"./assets/icons/svg/icon-close.svg": 50829,
	"./assets/icons/svg/icon-copy.svg": 54171,
	"./assets/icons/svg/icon-lfg.svg": 54012,
	"./assets/icons/svg/icon-ok.svg": 35686,
	"./assets/icons/svg/icon-telegram.svg": 45810,
	"./assets/icons/svg/icon-user.svg": 8639,
	"./assets/images/goldcoin/12.png": 40990,
	"./assets/images/goldcoin/BIGTON.png": 48572,
	"./assets/images/goldcoin/TONwallet.png": 75500,
	"./assets/images/goldcoin/airdrop-big.png": 19217,
	"./assets/images/goldcoin/airdrop-channel.png": 29221,
	"./assets/images/goldcoin/airdrop-freemint.png": 5702,
	"./assets/images/goldcoin/airdrop-left-bg.jpg": 67801,
	"./assets/images/goldcoin/airdrop-ok.png": 59226,
	"./assets/images/goldcoin/airdrop-right-bg.jpg": 17440,
	"./assets/images/goldcoin/airdrop-usdt-coin.png": 1625,
	"./assets/images/goldcoin/airdrop-wallet.png": 57096,
	"./assets/images/goldcoin/airdrop.png": 3089,
	"./assets/images/goldcoin/award.png": 10936,
	"./assets/images/goldcoin/award_tip.jpg": 95017,
	"./assets/images/goldcoin/boost-list-icon-1.png": 48877,
	"./assets/images/goldcoin/boost-list-icon-2.png": 81890,
	"./assets/images/goldcoin/boost-list-icon-3.png": 27043,
	"./assets/images/goldcoin/boost-list-icon-4.png": 77182,
	"./assets/images/goldcoin/boost-list-icon-5.png": 52831,
	"./assets/images/goldcoin/boost-list-icon-6.png": 85329,
	"./assets/images/goldcoin/btn-icon-boost.png": 29464,
	"./assets/images/goldcoin/code-icon-0.png": 96771,
	"./assets/images/goldcoin/daily-invite.png": 25145,
	"./assets/images/goldcoin/earn-head-icon-gift.png": 97256,
	"./assets/images/goldcoin/earn-head-icon-silver.png": 51610,
	"./assets/images/goldcoin/earn-icon-0.png": 33586,
	"./assets/images/goldcoin/earn-list-icon-1.png": 52392,
	"./assets/images/goldcoin/earn-list-icon-2.png": 18652,
	"./assets/images/goldcoin/earn-list-icon-gift.png": 69500,
	"./assets/images/goldcoin/finish.png": 10325,
	"./assets/images/goldcoin/frens-1.png": 89393,
	"./assets/images/goldcoin/frens-2.png": 36800,
	"./assets/images/goldcoin/frens-3.png": 99721,
	"./assets/images/goldcoin/hoe.png": 83215,
	"./assets/images/goldcoin/icon-arrow.png": 53570,
	"./assets/images/goldcoin/icon-earth.png": 6534,
	"./assets/images/goldcoin/index-bg.jpg": 73858,
	"./assets/images/goldcoin/index-btn-boost.png": 70693,
	"./assets/images/goldcoin/index-btn-earn.png": 73344,
	"./assets/images/goldcoin/index-btn-frens.png": 64028,
	"./assets/images/goldcoin/index-btn-home.png": 68350,
	"./assets/images/goldcoin/index-btn-lottery.png": 92750,
	"./assets/images/goldcoin/index-btn-mine.png": 50317,
	"./assets/images/goldcoin/index-btn-ranking.png": 81299,
	"./assets/images/goldcoin/index-btn-silver-earn.png": 59475,
	"./assets/images/goldcoin/index-icon-big-coin.png": 26993,
	"./assets/images/goldcoin/index-icon-bronze.png": 124,
	"./assets/images/goldcoin/index-icon-energy.png": 83148,
	"./assets/images/goldcoin/index-icon-level.png": 92370,
	"./assets/images/goldcoin/index-icon-small-coin.png": 72070,
	"./assets/images/goldcoin/index-icon-small-silver-coin.png": 56301,
	"./assets/images/goldcoin/index-icon-squad.png": 83458,
	"./assets/images/goldcoin/inset-bg.jpg": 25790,
	"./assets/images/goldcoin/join-icon-frens.png": 74770,
	"./assets/images/goldcoin/level/Bronze.png": 85690,
	"./assets/images/goldcoin/level/Diamond.png": 48333,
	"./assets/images/goldcoin/level/Emerald.png": 14430,
	"./assets/images/goldcoin/level/Gold.png": 6879,
	"./assets/images/goldcoin/level/Platinum.png": 30650,
	"./assets/images/goldcoin/level/Ruby.png": 9061,
	"./assets/images/goldcoin/level/Silver.png": 68801,
	"./assets/images/goldcoin/level/Wish.png": 78736,
	"./assets/images/goldcoin/loading.gif": 81515,
	"./assets/images/goldcoin/lock.png": 95453,
	"./assets/images/goldcoin/lottery-icon.png": 52960,
	"./assets/images/goldcoin/menu-bg.png": 80734,
	"./assets/images/goldcoin/pop-award-icon-0.png": 17116,
	"./assets/images/goldcoin/pop-coin-hero-icon-0.png": 22785,
	"./assets/images/goldcoin/pop-up-gold-icon-0.png": 60289,
	"./assets/images/goldcoin/rank-1.png": 35595,
	"./assets/images/goldcoin/rank-2.png": 51193,
	"./assets/images/goldcoin/rank-3.png": 13268,
	"./assets/images/goldcoin/rank-bronze.png": 37156,
	"./assets/images/goldcoin/sd.png": 55461,
	"./assets/images/goldcoin/sign-calendar.png": 15319,
	"./assets/images/goldcoin/squad-icon-1.png": 38583,
	"./assets/images/goldcoin/squad-icon-2.png": 85913,
	"./assets/images/goldcoin/squad-icon-3.png": 58432,
	"./assets/images/goldcoin/squad-icon-4.png": 86685,
	"./assets/images/goldcoin/squad-icon-5.png": 33705,
	"./assets/images/goldcoin/stone_1.png": 31728,
	"./assets/images/goldcoin/stone_2.png": 78809,
	"./assets/images/goldcoin/stone_bg.png": 12202,
	"./assets/images/goldcoin/stone_s_1.png": 17302,
	"./assets/images/goldcoin/stone_s_2.png": 13416,
	"./assets/images/goldcoin/stone_s_3.png": 16399,
	"./assets/images/goldcoin/stone_s_4.png": 5863,
	"./assets/images/goldcoin/tap.mp3": 8669,
	"./assets/images/goldcoin/task-detail-arrow.png": 25399,
	"./assets/images/goldcoin/task-detail-arrow2.png": 18814,
	"./assets/images/goldcoin/task-detail-bg.jpg": 31240,
	"./assets/images/goldcoin/task-detail-step-1.jpg": 55597,
	"./assets/images/goldcoin/task-detail-step-2.jpg": 62633,
	"./assets/images/goldcoin/task-detail-step-3.jpg": 58960,
	"./assets/images/goldcoin/task-detail-step-4.jpg": 43242,
	"./assets/images/goldcoin/time.png": 37181,
	"./assets/images/goldcoin/tip.png": 5558,
	"./assets/images/goldcoin/tron.png": 30661,
	"./assets/images/goldcoin/turbo.png": 32659,
	"./assets/images/goldcoin/unknown.png": 91781,
	"./assets/images/memetown/12.png": 16856,
	"./assets/images/memetown/BIGTON.png": 45460,
	"./assets/images/memetown/TONwallet.png": 80953,
	"./assets/images/memetown/airdrop-big.png": 68300,
	"./assets/images/memetown/airdrop-channel.png": 65003,
	"./assets/images/memetown/airdrop-freemint.png": 1275,
	"./assets/images/memetown/airdrop-left-bg.jpg": 45111,
	"./assets/images/memetown/airdrop-ok.png": 47562,
	"./assets/images/memetown/airdrop-right-bg.jpg": 92343,
	"./assets/images/memetown/airdrop-usdt-coin.png": 36317,
	"./assets/images/memetown/airdrop-wallet.png": 7051,
	"./assets/images/memetown/airdrop.png": 32348,
	"./assets/images/memetown/award.png": 36810,
	"./assets/images/memetown/award_tip.jpg": 7766,
	"./assets/images/memetown/boost-list-icon-1.png": 59093,
	"./assets/images/memetown/boost-list-icon-2.png": 11355,
	"./assets/images/memetown/boost-list-icon-3.png": 99981,
	"./assets/images/memetown/boost-list-icon-4.png": 23229,
	"./assets/images/memetown/boost-list-icon-5.png": 76537,
	"./assets/images/memetown/boost-list-icon-6.png": 34072,
	"./assets/images/memetown/btn-icon-boost.png": 4477,
	"./assets/images/memetown/code-icon-0.png": 57793,
	"./assets/images/memetown/daily-invite.png": 14015,
	"./assets/images/memetown/earn-head-icon-gift.png": 46815,
	"./assets/images/memetown/earn-head-icon-silver.png": 43263,
	"./assets/images/memetown/earn-icon-0.png": 65403,
	"./assets/images/memetown/earn-list-icon-1.png": 51978,
	"./assets/images/memetown/earn-list-icon-2.png": 67151,
	"./assets/images/memetown/earn-list-icon-gift.png": 9931,
	"./assets/images/memetown/finish.png": 34545,
	"./assets/images/memetown/frens-1.png": 43722,
	"./assets/images/memetown/frens-2.png": 90595,
	"./assets/images/memetown/frens-3.png": 60147,
	"./assets/images/memetown/hoe.png": 17322,
	"./assets/images/memetown/icon-arrow.png": 28091,
	"./assets/images/memetown/icon-earth.png": 87161,
	"./assets/images/memetown/index-bg.jpg": 24126,
	"./assets/images/memetown/index-btn-boost.png": 80937,
	"./assets/images/memetown/index-btn-earn.png": 75889,
	"./assets/images/memetown/index-btn-frens.png": 67884,
	"./assets/images/memetown/index-btn-home.png": 36285,
	"./assets/images/memetown/index-btn-lottery.png": 61748,
	"./assets/images/memetown/index-btn-mine.png": 31242,
	"./assets/images/memetown/index-btn-ranking.png": 29517,
	"./assets/images/memetown/index-btn-silver-earn.png": 77436,
	"./assets/images/memetown/index-icon-big-coin.png": 50723,
	"./assets/images/memetown/index-icon-bronze.png": 74514,
	"./assets/images/memetown/index-icon-energy.png": 91035,
	"./assets/images/memetown/index-icon-level.png": 43292,
	"./assets/images/memetown/index-icon-small-coin.png": 96817,
	"./assets/images/memetown/index-icon-small-silver-coin.png": 89449,
	"./assets/images/memetown/index-icon-squad.png": 29563,
	"./assets/images/memetown/inset-bg.jpg": 12018,
	"./assets/images/memetown/inset-bg2.png": 66004,
	"./assets/images/memetown/join-icon-frens.png": 18555,
	"./assets/images/memetown/level/Bronze.png": 76969,
	"./assets/images/memetown/level/Diamond.png": 14457,
	"./assets/images/memetown/level/Emerald.png": 54280,
	"./assets/images/memetown/level/Gold.png": 43859,
	"./assets/images/memetown/level/Platinum.png": 98246,
	"./assets/images/memetown/level/Ruby.png": 82347,
	"./assets/images/memetown/level/Silver.png": 12829,
	"./assets/images/memetown/level/Wish.png": 18963,
	"./assets/images/memetown/lock.png": 41877,
	"./assets/images/memetown/lottery-icon.png": 11483,
	"./assets/images/memetown/menu-bg.png": 51772,
	"./assets/images/memetown/pop-award-icon-0.png": 49847,
	"./assets/images/memetown/pop-coin-hero-icon-0.png": 72004,
	"./assets/images/memetown/pop-up-gold-icon-0.png": 21501,
	"./assets/images/memetown/rank-1.png": 26057,
	"./assets/images/memetown/rank-2.png": 67639,
	"./assets/images/memetown/rank-3.png": 19986,
	"./assets/images/memetown/rank-bronze.png": 3687,
	"./assets/images/memetown/sd.png": 72894,
	"./assets/images/memetown/sign-calendar.png": 77925,
	"./assets/images/memetown/squad-icon-1.png": 8929,
	"./assets/images/memetown/squad-icon-2.png": 97192,
	"./assets/images/memetown/squad-icon-3.png": 25507,
	"./assets/images/memetown/squad-icon-4.png": 45423,
	"./assets/images/memetown/squad-icon-5.png": 35743,
	"./assets/images/memetown/stone_1.png": 56986,
	"./assets/images/memetown/stone_2.png": 68147,
	"./assets/images/memetown/stone_bg.png": 7147,
	"./assets/images/memetown/stone_s_1.png": 54297,
	"./assets/images/memetown/stone_s_2.png": 50011,
	"./assets/images/memetown/stone_s_3.png": 54704,
	"./assets/images/memetown/stone_s_4.png": 87167,
	"./assets/images/memetown/task-detail-arrow.png": 11632,
	"./assets/images/memetown/task-detail-arrow2.png": 29789,
	"./assets/images/memetown/task-detail-bg.jpg": 98531,
	"./assets/images/memetown/task-detail-step-1.jpg": 67223,
	"./assets/images/memetown/task-detail-step-2.jpg": 38167,
	"./assets/images/memetown/task-detail-step-3.jpg": 45396,
	"./assets/images/memetown/task-detail-step-4.jpg": 54513,
	"./assets/images/memetown/time.png": 87168,
	"./assets/images/memetown/tip.png": 30346,
	"./assets/images/memetown/tron.png": 92940,
	"./assets/images/memetown/turbo.png": 56819,
	"./assets/images/memetown/unknown.png": 49094,
	"./assets/images/reflection/BIGTON.png": 70116,
	"./assets/images/reflection/TONwallet.png": 53887,
	"./assets/images/reflection/airdrop-big.png": 68628,
	"./assets/images/reflection/airdrop-channel.png": 22647,
	"./assets/images/reflection/airdrop-freemint.png": 78864,
	"./assets/images/reflection/airdrop-left-bg.jpg": 60731,
	"./assets/images/reflection/airdrop-ok.png": 45048,
	"./assets/images/reflection/airdrop-right-bg.jpg": 62888,
	"./assets/images/reflection/airdrop-usdt-coin.png": 63217,
	"./assets/images/reflection/airdrop-wallet.png": 52691,
	"./assets/images/reflection/airdrop.png": 7960,
	"./assets/images/reflection/award.png": 91318,
	"./assets/images/reflection/award_tip.jpg": 938,
	"./assets/images/reflection/boost-list-icon-1.png": 4495,
	"./assets/images/reflection/boost-list-icon-2.png": 57204,
	"./assets/images/reflection/boost-list-icon-3.png": 34636,
	"./assets/images/reflection/boost-list-icon-4.png": 47166,
	"./assets/images/reflection/boost-list-icon-5.png": 37581,
	"./assets/images/reflection/boost-list-icon-6.png": 84988,
	"./assets/images/reflection/btn-icon-boost.png": 82096,
	"./assets/images/reflection/code-icon-0.png": 64022,
	"./assets/images/reflection/daily-invite.png": 62299,
	"./assets/images/reflection/earn-head-icon-gift.png": 97592,
	"./assets/images/reflection/earn-head-icon-silver.png": 70368,
	"./assets/images/reflection/earn-icon-0.png": 81145,
	"./assets/images/reflection/earn-list-icon-1.png": 15429,
	"./assets/images/reflection/earn-list-icon-2.png": 29842,
	"./assets/images/reflection/earn-list-icon-gift.png": 53979,
	"./assets/images/reflection/finish.png": 13061,
	"./assets/images/reflection/frens-1.png": 94127,
	"./assets/images/reflection/frens-2.png": 15397,
	"./assets/images/reflection/frens-3.png": 49930,
	"./assets/images/reflection/hoe.png": 17557,
	"./assets/images/reflection/icon-arrow.png": 97453,
	"./assets/images/reflection/icon-earth.png": 22676,
	"./assets/images/reflection/index-bg.jpg": 23443,
	"./assets/images/reflection/index-btn-boost.png": 32941,
	"./assets/images/reflection/index-btn-earn.png": 22028,
	"./assets/images/reflection/index-btn-frens.png": 88482,
	"./assets/images/reflection/index-btn-home.png": 27885,
	"./assets/images/reflection/index-btn-lottery.png": 17561,
	"./assets/images/reflection/index-btn-mine.png": 71730,
	"./assets/images/reflection/index-btn-ranking.png": 33833,
	"./assets/images/reflection/index-btn-silver-earn.png": 80389,
	"./assets/images/reflection/index-icon-big-coin.png": 34844,
	"./assets/images/reflection/index-icon-bronze.png": 82914,
	"./assets/images/reflection/index-icon-energy.png": 79724,
	"./assets/images/reflection/index-icon-level.png": 2810,
	"./assets/images/reflection/index-icon-small-coin.png": 72572,
	"./assets/images/reflection/index-icon-small-silver-coin.png": 25890,
	"./assets/images/reflection/index-icon-squad.png": 38825,
	"./assets/images/reflection/inset-bg.jpg": 429,
	"./assets/images/reflection/join-icon-frens.png": 59495,
	"./assets/images/reflection/level/Bronze.png": 9040,
	"./assets/images/reflection/level/Diamond.png": 97456,
	"./assets/images/reflection/level/Emerald.png": 58531,
	"./assets/images/reflection/level/Gold.png": 48993,
	"./assets/images/reflection/level/Platinum.png": 82867,
	"./assets/images/reflection/level/Ruby.png": 77339,
	"./assets/images/reflection/level/Silver.png": 91250,
	"./assets/images/reflection/level/Wish.png": 63044,
	"./assets/images/reflection/loading.webp": 53410,
	"./assets/images/reflection/lock.png": 27747,
	"./assets/images/reflection/lottery-icon.png": 94430,
	"./assets/images/reflection/menu-bg.png": 65866,
	"./assets/images/reflection/pop-award-icon-0.png": 63218,
	"./assets/images/reflection/pop-coin-hero-icon-0.png": 30563,
	"./assets/images/reflection/pop-up-gold-icon-0.png": 34004,
	"./assets/images/reflection/rank-1.png": 52550,
	"./assets/images/reflection/rank-2.png": 4366,
	"./assets/images/reflection/rank-3.png": 62043,
	"./assets/images/reflection/rank-bronze.png": 4595,
	"./assets/images/reflection/sd.png": 73491,
	"./assets/images/reflection/sign-calendar.png": 48597,
	"./assets/images/reflection/squad-icon-1.png": 61267,
	"./assets/images/reflection/squad-icon-2.png": 91421,
	"./assets/images/reflection/squad-icon-3.png": 47356,
	"./assets/images/reflection/squad-icon-4.png": 75002,
	"./assets/images/reflection/squad-icon-5.png": 63688,
	"./assets/images/reflection/stone_1.png": 96132,
	"./assets/images/reflection/stone_2.png": 44444,
	"./assets/images/reflection/stone_bg.png": 57867,
	"./assets/images/reflection/stone_s_1.png": 6588,
	"./assets/images/reflection/stone_s_2.png": 48965,
	"./assets/images/reflection/stone_s_3.png": 69044,
	"./assets/images/reflection/stone_s_4.png": 31268,
	"./assets/images/reflection/tap.mp3": 70669,
	"./assets/images/reflection/task-detail-arrow.png": 14393,
	"./assets/images/reflection/task-detail-arrow2.png": 24154,
	"./assets/images/reflection/task-detail-bg.jpg": 39844,
	"./assets/images/reflection/task-detail-step-1.jpg": 33145,
	"./assets/images/reflection/task-detail-step-2.jpg": 28896,
	"./assets/images/reflection/task-detail-step-3.jpg": 27475,
	"./assets/images/reflection/task-detail-step-4.jpg": 85362,
	"./assets/images/reflection/time.png": 83429,
	"./assets/images/reflection/tip.png": 6419,
	"./assets/images/reflection/tron.png": 34967,
	"./assets/images/reflection/turbo.png": 62266,
	"./assets/images/reflection/unknown.png": 97847,
	"./assets/images/tapcoin/BIGTON.png": 92775,
	"./assets/images/tapcoin/TONwallet.png": 1280,
	"./assets/images/tapcoin/airdrop-big.png": 86780,
	"./assets/images/tapcoin/airdrop-channel.png": 85745,
	"./assets/images/tapcoin/airdrop-freemint.png": 44746,
	"./assets/images/tapcoin/airdrop-left-bg.jpg": 67310,
	"./assets/images/tapcoin/airdrop-ok.png": 2664,
	"./assets/images/tapcoin/airdrop-right-bg.jpg": 78149,
	"./assets/images/tapcoin/airdrop-wallet.png": 70284,
	"./assets/images/tapcoin/airdrop.png": 73971,
	"./assets/images/tapcoin/award.png": 78171,
	"./assets/images/tapcoin/award_tip.jpg": 35234,
	"./assets/images/tapcoin/boost-list-icon-1.png": 15035,
	"./assets/images/tapcoin/boost-list-icon-2.png": 72043,
	"./assets/images/tapcoin/boost-list-icon-3.png": 43444,
	"./assets/images/tapcoin/boost-list-icon-4.png": 4681,
	"./assets/images/tapcoin/boost-list-icon-5.png": 67241,
	"./assets/images/tapcoin/boost-list-icon-6.png": 2970,
	"./assets/images/tapcoin/btn-icon-boost.png": 97498,
	"./assets/images/tapcoin/code-icon-0.png": 2913,
	"./assets/images/tapcoin/daily-invite.png": 49729,
	"./assets/images/tapcoin/earn-head-icon-gift.png": 59216,
	"./assets/images/tapcoin/earn-icon-0.png": 43847,
	"./assets/images/tapcoin/earn-list-icon-1.png": 349,
	"./assets/images/tapcoin/earn-list-icon-2.png": 45090,
	"./assets/images/tapcoin/earn-list-icon-gift.png": 95596,
	"./assets/images/tapcoin/finish.png": 26059,
	"./assets/images/tapcoin/frens-1.png": 44604,
	"./assets/images/tapcoin/frens-2.png": 32854,
	"./assets/images/tapcoin/frens-3.png": 28306,
	"./assets/images/tapcoin/index-bg-1.jpg": 62848,
	"./assets/images/tapcoin/index-bg.jpg": 63156,
	"./assets/images/tapcoin/index-btn-airdrop.png": 21553,
	"./assets/images/tapcoin/index-btn-boost.png": 30586,
	"./assets/images/tapcoin/index-btn-earn.png": 3263,
	"./assets/images/tapcoin/index-btn-frens.png": 94744,
	"./assets/images/tapcoin/index-btn-home.png": 20638,
	"./assets/images/tapcoin/index-btn-icon-1.png": 36013,
	"./assets/images/tapcoin/index-btn-icon-2.png": 7031,
	"./assets/images/tapcoin/index-btn-icon-3.png": 64551,
	"./assets/images/tapcoin/index-btn-lottery.png": 95357,
	"./assets/images/tapcoin/index-btn-mine.png": 6368,
	"./assets/images/tapcoin/index-c-btn-bg.png": 80124,
	"./assets/images/tapcoin/index-icon-big-coin.png": 57569,
	"./assets/images/tapcoin/index-icon-bronze.png": 45580,
	"./assets/images/tapcoin/index-icon-energy.png": 58052,
	"./assets/images/tapcoin/index-icon-level.png": 75009,
	"./assets/images/tapcoin/index-icon-small-coin.png": 68841,
	"./assets/images/tapcoin/index-icon-squad-1.png": 98556,
	"./assets/images/tapcoin/index-icon-squad.png": 21273,
	"./assets/images/tapcoin/inset-bg-1.jpg": 88991,
	"./assets/images/tapcoin/inset-bg.jpg": 62836,
	"./assets/images/tapcoin/join-icon-frens.png": 25786,
	"./assets/images/tapcoin/level/Bronze.png": 81649,
	"./assets/images/tapcoin/level/Diamond.png": 17308,
	"./assets/images/tapcoin/level/Emerald.png": 39975,
	"./assets/images/tapcoin/level/Gold.png": 88027,
	"./assets/images/tapcoin/level/Platinum.png": 96604,
	"./assets/images/tapcoin/level/Ruby.png": 29676,
	"./assets/images/tapcoin/level/Silver.png": 97004,
	"./assets/images/tapcoin/level/Wish.png": 85792,
	"./assets/images/tapcoin/loading.gif": 28272,
	"./assets/images/tapcoin/lock.png": 72193,
	"./assets/images/tapcoin/lottery-icon.png": 55375,
	"./assets/images/tapcoin/menu-bg.png": 5620,
	"./assets/images/tapcoin/pop-award-icon-0.png": 79986,
	"./assets/images/tapcoin/pop-coin-hero-icon-0.png": 63230,
	"./assets/images/tapcoin/pop-up-gold-icon-0.png": 9611,
	"./assets/images/tapcoin/rank-1.png": 19162,
	"./assets/images/tapcoin/rank-2.png": 32030,
	"./assets/images/tapcoin/rank-3.png": 78368,
	"./assets/images/tapcoin/rank-bronze.png": 44222,
	"./assets/images/tapcoin/sd.png": 18773,
	"./assets/images/tapcoin/sign-calendar.png": 18976,
	"./assets/images/tapcoin/squad-icon-1.png": 54583,
	"./assets/images/tapcoin/squad-icon-2.png": 44481,
	"./assets/images/tapcoin/squad-icon-3.png": 3355,
	"./assets/images/tapcoin/squad-icon-4.png": 83051,
	"./assets/images/tapcoin/task-detail-arrow.png": 50056,
	"./assets/images/tapcoin/task-detail-arrow2.png": 88161,
	"./assets/images/tapcoin/task-detail-bg.jpg": 68183,
	"./assets/images/tapcoin/task-detail-step-1.jpg": 82173,
	"./assets/images/tapcoin/task-detail-step-2.jpg": 50133,
	"./assets/images/tapcoin/task-detail-step-3.jpg": 4134,
	"./assets/images/tapcoin/task-detail-step-4.jpg": 26725,
	"./assets/images/tapcoin/time.png": 92661,
	"./assets/images/tapcoin/tip.png": 62136,
	"./assets/images/tapcoin/tonview.png": 88083,
	"./assets/images/tapcoin/tron.png": 89486,
	"./assets/images/tapcoin/turbo.png": 11278,
	"./assets/images/tapcoin/unknown.png": 70001,
	"./assets/images/tapcoin/usdt-p.png": 65984,
	"./assets/images/tapcoin/usdt.png": 44777,
	"./assets/js/hoejs": 63964,
	"./assets/js/hoejs.js": 63964,
	"./assets/js/noZoom": 62654,
	"./assets/js/noZoom.js": 62654,
	"./assets/js/rem": 79633,
	"./assets/js/rem.js": 79633,
	"./components/btnBack": 71116,
	"./components/btnBack.vue": 71116,
	"./components/countUp": 9058,
	"./components/countUp.vue": 9058,
	"./components/index/goldcoinIndex": 7885,
	"./components/index/goldcoinIndex.vue": 7885,
	"./components/index/memetownIndex": 42672,
	"./components/index/memetownIndex.vue": 42672,
	"./components/index/reflectionIndex": 4839,
	"./components/index/reflectionIndex.vue": 4839,
	"./components/index/tapcoinIndex": 12637,
	"./components/index/tapcoinIndex.vue": 12637,
	"./components/layout": 1386,
	"./components/layout.vue": 1386,
	"./components/mHead": 83109,
	"./components/mHead.vue": 83109,
	"./components/mMenu": 16673,
	"./components/mMenu.vue": 16673,
	"./components/myLoading": 59478,
	"./components/myLoading/": 59478,
	"./components/myLoading/index": 59478,
	"./components/myLoading/index.js": 59478,
	"./components/myLoading/myLoading": 12229,
	"./components/myLoading/myLoading.scss": 40735,
	"./components/myLoading/myLoading.vue": 12229,
	"./components/myTile/myTile": 1308,
	"./components/myTile/myTile.vue": 1308,
	"./components/myTile/vanilla-tilt": 81043,
	"./components/myTile/vanilla-tilt.js": 81043,
	"./components/popAirdropTip": 69313,
	"./components/popAirdropTip.vue": 69313,
	"./components/popAward": 36429,
	"./components/popAward.vue": 36429,
	"./components/popAwardTip": 5802,
	"./components/popAwardTip.vue": 5802,
	"./components/popBindWallet": 92685,
	"./components/popBindWallet.vue": 92685,
	"./components/popCoinHero": 77861,
	"./components/popCoinHero.vue": 77861,
	"./components/popDialog": 61390,
	"./components/popDialog.vue": 61390,
	"./components/popEnergy": 40517,
	"./components/popEnergy.vue": 40517,
	"./components/popExtraInvite": 57161,
	"./components/popExtraInvite.vue": 57161,
	"./components/popGetAward": 58089,
	"./components/popGetAward.vue": 58089,
	"./components/popJoin": 93886,
	"./components/popJoin.vue": 93886,
	"./components/popLoginReward": 85402,
	"./components/popLoginReward.vue": 85402,
	"./components/popLotteryJoin": 48422,
	"./components/popLotteryJoin.vue": 48422,
	"./components/popMethod": 91574,
	"./components/popMethod.vue": 91574,
	"./components/popMineEnergy": 7365,
	"./components/popMineEnergy.vue": 7365,
	"./components/popPrompt": 42702,
	"./components/popPrompt.vue": 42702,
	"./components/popRobot": 88591,
	"./components/popRobot.vue": 88591,
	"./components/popSelectToken": 6048,
	"./components/popSelectToken.vue": 6048,
	"./components/popShare": 29776,
	"./components/popShare.vue": 29776,
	"./components/popSpecialDetail": 4453,
	"./components/popSpecialDetail.vue": 4453,
	"./components/popSquad": 72994,
	"./components/popSquad.vue": 72994,
	"./components/popTipEnergy": 14014,
	"./components/popTipEnergy.vue": 14014,
	"./components/popTipTaskDetail": 10046,
	"./components/popTipTaskDetail.vue": 10046,
	"./components/popUpGold": 25013,
	"./components/popUpGold.vue": 25013,
	"./components/svgIcon": 43234,
	"./components/svgIcon.vue": 43234,
	"./config": 6846,
	"./config/": 6846,
	"./config/index": 6846,
	"./config/index.js": 6846,
	"./directive": 90973,
	"./directive/": 90973,
	"./directive/direct/v-anchor": 52828,
	"./directive/direct/v-anchor.js": 52828,
	"./directive/direct/v-copy": 44404,
	"./directive/direct/v-copy.js": 44404,
	"./directive/direct/v-debounce": 64459,
	"./directive/direct/v-debounce.js": 64459,
	"./directive/direct/v-draggable": 52971,
	"./directive/direct/v-draggable.js": 52971,
	"./directive/direct/v-scroll": 57660,
	"./directive/direct/v-scroll.js": 57660,
	"./directive/direct/v-shuibowen": 73131,
	"./directive/direct/v-shuibowen.js": 73131,
	"./directive/index": 90973,
	"./directive/index.js": 90973,
	"./http": 11063,
	"./http/": 11063,
	"./http/index": 11063,
	"./http/index.js": 11063,
	"./i18n": 86926,
	"./i18n/": 86926,
	"./i18n/i18nOption": 17292,
	"./i18n/i18nOption.json": 17292,
	"./i18n/index": 86926,
	"./i18n/index.js": 86926,
	"./i18n/json/Chs": 15077,
	"./i18n/json/Chs.json": 15077,
	"./i18n/json/En": 74030,
	"./i18n/json/En.json": 74030,
	"./main": 43217,
	"./main.js": 43217,
	"./router": 15092,
	"./router/": 15092,
	"./router/index": 15092,
	"./router/index.js": 15092,
	"./store": 68854,
	"./store/": 68854,
	"./store/index": 68854,
	"./store/index.js": 68854,
	"./store/modules/airdrop": 28913,
	"./store/modules/airdrop.js": 28913,
	"./store/modules/assets": 24863,
	"./store/modules/assets.js": 24863,
	"./store/modules/autobot": 54855,
	"./store/modules/autobot.js": 54855,
	"./store/modules/daily": 51572,
	"./store/modules/daily.js": 51572,
	"./store/modules/lottery": 43136,
	"./store/modules/lottery.js": 43136,
	"./store/modules/mine": 40821,
	"./store/modules/mine.js": 40821,
	"./store/modules/ranking": 51734,
	"./store/modules/ranking.js": 51734,
	"./store/modules/squad": 20849,
	"./store/modules/squad.js": 20849,
	"./store/modules/task": 72390,
	"./store/modules/task.js": 72390,
	"./store/modules/user": 69220,
	"./store/modules/user.js": 69220,
	"./store/modules/wallet": 9944,
	"./store/modules/wallet.js": 9944,
	"./tonWallet": 88929,
	"./tonWallet/": 88929,
	"./tonWallet/index": 88929,
	"./tonWallet/index.js": 88929,
	"./utils": 1474,
	"./utils/": 1474,
	"./utils/errcode": 48956,
	"./utils/errcode.js": 48956,
	"./utils/formatter": 83291,
	"./utils/formatter.js": 83291,
	"./utils/index": 1474,
	"./utils/index.js": 1474,
	"./view": 2882,
	"./view/": 2882,
	"./view/DailyInvite": 88032,
	"./view/DailyInvite.vue": 88032,
	"./view/airdrop": 52085,
	"./view/airdrop.vue": 52085,
	"./view/airdrop2": 5706,
	"./view/airdrop2.vue": 5706,
	"./view/airdropReward": 56470,
	"./view/airdropReward.vue": 56470,
	"./view/boost": 17685,
	"./view/boost.vue": 17685,
	"./view/code": 92354,
	"./view/code.vue": 92354,
	"./view/earn": 79042,
	"./view/earn.vue": 79042,
	"./view/frens": 77453,
	"./view/frens.vue": 77453,
	"./view/index": 2882,
	"./view/index.vue": 2882,
	"./view/join": 78746,
	"./view/join.vue": 78746,
	"./view/lottery": 18733,
	"./view/lottery.vue": 18733,
	"./view/lotteryDetail": 43047,
	"./view/lotteryDetail.vue": 43047,
	"./view/mine": 87904,
	"./view/mine.vue": 87904,
	"./view/rank": 93235,
	"./view/rank.vue": 93235,
	"./view/sign": 77680,
	"./view/sign.vue": 77680,
	"./view/squad": 56554,
	"./view/squad.vue": 56554,
	"./view/taskDetail": 91131,
	"./view/taskDetail.vue": 91131,
	"./web3Wallet": 79305,
	"./web3Wallet/": 79305,
	"./web3Wallet/config/config": 7935,
	"./web3Wallet/config/config.json": 7935,
	"./web3Wallet/config_for_test/config": 94175,
	"./web3Wallet/config_for_test/config.json": 94175,
	"./web3Wallet/contracts/market": 37496,
	"./web3Wallet/contracts/market.json": 37496,
	"./web3Wallet/contracts/market_old": 64409,
	"./web3Wallet/contracts/market_old.json": 64409,
	"./web3Wallet/contracts_for_test/market": 30551,
	"./web3Wallet/contracts_for_test/market.json": 30551,
	"./web3Wallet/contracts_for_test/market_old": 4076,
	"./web3Wallet/contracts_for_test/market_old.json": 4076,
	"./web3Wallet/index": 79305,
	"./web3Wallet/index.js": 79305
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18116;